import { useState, useCallback } from "react";
import { apiFetch } from "../lib/api";

interface GenerateParams {
  tab: string;
  wine: string;
  lang: string;
  maison?: string;
  pdfTxt?: string;
  imgB64?: string | null;
}

interface GenerateResult {
  text: string;
  prompt: string;
}

export function useGeneration() {
  const [loading, setLoading] = useState(false);

  const generateContent = useCallback(async (params: GenerateParams): Promise<GenerateResult> => {
    setLoading(true);
    try {
      const res = await apiFetch(`/generation/content`, {
        method: "POST",
        body: JSON.stringify(params),
      }, { auth: false });
      if (!res.ok) {
        const err = await res.json().catch(() => ({ error: "Erreur de génération." }));
        throw new Error(err.error || "Erreur de génération.");
      }
      const data = await res.json();
      return data;
    } finally {
      setLoading(false);
    }
  }, []);

  const generateCarteDesc = useCallback(async (wineId: string): Promise<string> => {
    const res = await apiFetch(`/generation/carte/${wineId}`, {
      method: "POST",
    });
    if (!res.ok) throw new Error("Erreur lors de la génération de la fiche.");
    const data = await res.json();
    return data.text;
  }, []);

  const generateBatch = useCallback(async () => {
    const res = await apiFetch(`/generation/batch`, {
      method: "POST",
    });
    if (!res.ok) throw new Error("Erreur lors de la génération groupée.");
    return res.json();
  }, []);

  const parseCSV = useCallback(async (raw: string) => {
    const res = await apiFetch(`/generation/parse-csv`, {
      method: "POST",
      body: JSON.stringify({ raw }),
    }, { auth: false });
    if (!res.ok) throw new Error("Erreur lors de l'analyse du CSV.");
    return res.json();
  }, []);

  return { loading, generateContent, generateCarteDesc, generateBatch, parseCSV };
}
